import { z } from "zod";
import { isCloudMetadataHost, isLoopbackHost, normalizeHost } from "./network-host.js";

export const EgressHost = z.string().trim().min(1).max(253)
  .regex(/^[a-zA-Z0-9.-]+$/, "Enter a hostname or IPv4 address")
  .transform(normalizeHost)
  .refine(value => value.split(".").every(label => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label)), "Enter a valid hostname")
  .refine(value => !isCloudMetadataHost(value) && !isLoopbackHost(value), "This address is not allowed");
export const LocalEgressStart = z.object({
  botId: z.string().min(1).max(128), deviceId: z.string().uuid(),
  minutes: z.number().int().min(1).max(480).default(30),
  privateHosts: z.array(EgressHost).max(20).default([]),
}).strict();
export type LocalEgressStart = z.infer<typeof LocalEgressStart>;
export const EgressTarget = z.object({
  kind: z.enum(["connect", "resolve"]), host: EgressHost,
  port: z.number().int().min(1).max(65535).optional(),
}).strict();
export type EgressTarget = z.infer<typeof EgressTarget>;
export const EgressId = z.string().min(1).max(128);
export const EgressPairInput = z.object({code:z.string().regex(/^[A-Za-z0-9_-]{22}$/),name:z.string().trim().min(1).max(64)}).strict();
export const EgressPolicyInput = z.object({enabled:z.boolean()}).strict();
export const EgressRevokeInput = z.object({deviceId:z.string().uuid()}).strict();
export const EgressBotInput = z.object({botId:EgressId}).strict();
